﻿((typeof exports != 'undefined' ? exports : {}).exec = function(isInIframe) {
Cognito.ready("entrylist", ["Cognito.Forms", "EntryList", "entryview"], function ($) {

//#region Controller

	// Top Controller
	var controller;
	if (ExoWeb.evalPath(window.parent, 'Cognito.Forms.controller')) {
		controller = isInIframe ? Cognito.Messaging.proxy(window.parent, "Cognito.Forms.controller") : Cognito.Forms.controller;
	}
	else {
		Cognito.Messaging.addHandler("controllerReady", function (data) {
			controller = isInIframe ? Cognito.Messaging.proxy(window.parent, "Cognito.Forms.controller") : Cognito.Forms.controller;
		});
	}

//#endregion

//#region Model Type Definitions

$extend(Cognito.Forms.model.entryTypeName, function (entry) {

	Cognito.Forms.entryType = entry;

	// Ensure the calculated order property is initialized
	if (entry.$Order) {
		entry.$Order.calculated({
			calculate: function () {
				if (!this.hasOwnProperty("_Order")) {
					this.set_Order(null);
				}
			}
		});
	}
});

$extend("Cognito.Payment.Order", function (order) {

	order.$SubTotal.calculated({
		calculate: function () {
			return this.get_LineItems().map(function (l) { return l.get_Amount(); }, this).reduce(function (p, c) { return p + c; }, 0);
		},
		onChangeOf: ["LineItems.Amount"]
	});

	order.$AdditionalFees.calculated({
		calculate: function () {
			return this.get_Fees().filter(function (li) { return !li.get_IsProcessingFee(); }, this).map(function (f) { return f.get_Amount(); }, this).reduce(function (p, c) { return p + c; }, 0);
		},
		onChangeOf: ["Fees{IsProcessingFee,Amount}"]
	});

	order.$ProcessingFees.calculated({
		calculate: function () {
			return this.get_Fees().filter(function (li) { return li.get_IsProcessingFee(); }, this).map(function (f) { return f.get_Amount(); }, this).reduce(function (p, c) { return p + c; }, 0);
		},
		onChangeOf: ["Fees{IsProcessingFee,Amount}"]
	});

	order.$OrderAmount.calculated({
		calculate: function () {
			return this.get_LineItems().map(function (f) { return f.get_Amount(); }, this)
				.reduce(function (p, c) { return p + c; }, 0) +
				this.get_Fees().map(function (f) { return f.get_Amount(); }, this)
				.reduce(function (p, c) { return p + c; }, 0);
		},
		onChangeOf: ["{LineItems.Amount,Fees.Amount}"]
	});

	order.$AmountDue.calculated({
		calculate: function () {
			return this.get_OrderAmount() - this.get_AmountPaid();
		},
		onChangeOf: ["{OrderAmount,AmountPaid}"]
	});

	order.$OrderSummary.calculated({
		calculate: function () {
			var status = this.get_PaymentStatus().get_Name();
			if (status === 'Paid')
				return this.get_AmountPaid().localeFormat("c") + " " + status;
			else if (status === 'Refunded')
				return this.get_RefundAmount().localeFormat("c") + " " + status;
			else if (status == 'Declined') {
				var amount = this.get_AmountDeclined() || this.get_OrderAmount();
				return amount.localeFormat("c") + " " + status;
			}
			else
				return this.get_OrderAmount().localeFormat("c") + " " + status;
		},
		onChangeOf: ["PaymentStatus", "AmountPaid", "RefundAmount", "OrderAmount", "AmountDeclined"]
	});
});

//#endregion

	function setupEntryStatusColorStylesAndData(){
		const statuses = Cognito.Forms.EntryStatuses[Cognito.Forms.model.entryTypeName];
		if (statuses.length && Cognito.config.workflowEnabled) {
			var statusColorCss = '';
			Cognito.Forms.model.statusMap = {}
			statuses.forEach(function(status) {
				statusColorCss += '\n.c-status-id--' + status.Id + ' .c-status-cell:before { background: ' + status.Color + '; }';
				Cognito.Forms.model.statusMap[status.Name] = status.Id;
			});

			Cognito.ready('status-styles', ['ExoWeb.dom'], function () {
				var styleId = 'c-entry-status-color-styles';
				var style = document.getElementById(styleId);
				if (style)
					style.remove();
				style = document.createElement('style');
				style.id = styleId;
				style.appendChild(document.createTextNode(statusColorCss));
				document.head.appendChild(style);
				document.body.classList.add('workflow');
			});
		}
	}

	Cognito.Forms.setupEntryStatusColorStylesAndData = setupEntryStatusColorStylesAndData;
});
})(typeof exports === 'undefined');